import { TextField, TextFieldProps } from '@mui/material'

type CustomTextFieldProps = TextFieldProps

const CustomTextField: React.FC<CustomTextFieldProps> = props => {
	return (
		<TextField
			sx={{
				width: '115px',
				'& .MuiFormLabel-root': {
					color: 'var(--primary-dark)',
					fontFamily: 'var(--font-family)',
					fontWeight: '400',
					fontSize: '11px',
					letterSpacing: '0.15px',
					lineHeight: '12px',
				},
				'& .Mui-disabled': {
					backgroundColor: 'rgba(245, 247, 252, 0.5)',
					border: 'none',
					'& input': {
						color: 'var(--primary-dark)',
						WebkitTextFillColor: 'var(--primary-dark)', // Ensures color for disabled input
						borderRadius: '4px',
					},

					'& > .MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},
				},
				'& input': {
					fontFamily: 'var(--font-family)',
					fontWeight: 500,
					fontSize: '13px',
					color: 'var(--primary-dark)',
					lineHeight: 1.3,
					'&.Mui-disabled': {
						backgroundColor: 'rgba(245, 247, 252)',
					},
				},
				'& input[type="time" i]::-webkit-calendar-picker-indicator': {
					backgroundImage: 'none',
				},
			}}
			InputProps={{
				sx: {
					color: 'var(--primary-dark)',
					WebkitTextFillColor: 'var(--primary-dark)',
					'& .Mui-disabled': {
						'& > .MuiOutlinedInput-notchedOutline': {
							borderColor: 'transparent',
						},
					},
				},
			}}
			{...props}
		/>
	)
}

export default CustomTextField
